import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";

export default function Navbar() {
  const { t } = useTranslation("common");
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: "/", label: t("nav.home") },
    { to: "/category/wanghong-dasai", label: t("nav.wanghongDasai") },
    { to: "/category/mingxing-bagua", label: t("nav.mingxingBagua") },
    { to: "/category/heiliaozhuizong", label: t("nav.heiliaozhuizong") },
    { to: "/category/chigua-shipin", label: t("nav.chiguaShipin") },
    { to: "/about", label: t("nav.about") },
  ];

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-2xl font-black tracking-tight transition-colors duration-300 ${
              scrolled || !isHome ? "text-primary-500" : "text-background-50"
            }`}>
              51爆料
            </span>
            <span className={`hidden sm:inline text-xs px-2 py-0.5 rounded-full font-label transition-colors duration-300 ${
              scrolled || !isHome
                ? "bg-primary-100 text-primary-700"
                : "bg-background-50/20 text-background-50"
            }`}>
              吃瓜集合站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to ||
                (link.to !== "/" && location.pathname.startsWith(link.to));
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 text-sm font-label rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    isActive
                      ? scrolled || !isHome
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50/20 text-background-50"
                      : scrolled || !isHome
                        ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                        : "text-background-50/80 hover:text-background-50 hover:bg-background-50/10"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl transition-colors duration-300 ${
              scrolled || !isHome ? "text-foreground-900" : "text-background-50"
            } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to ||
                (link.to !== "/" && location.pathname.startsWith(link.to));
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 text-sm font-label rounded-lg whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}